import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Printer, Scissors, Package } from "lucide-react";
import { allCategories } from "@/lib/dinner";
import { Nice } from "@/components/Nice";

const PER_PAGE = 8;

export default function PrintDinnerCards() {
  const [params] = useSearchParams();
  const categories = allCategories();
  const topics = params.get("topics")?.split(",") || categories.map((c) => c.id);
  const cards = categories.filter((c) => topics.includes(c.id))
    .flatMap((c) => c.questions.map((q) => ({ q, cat: c.label, id: c.id })));
  const pages = Array.from({ length: Math.ceil(cards.length / PER_PAGE) }, (_, i) => cards.slice(i * PER_PAGE, (i + 1) * PER_PAGE));

  useEffect(() => { const t = setTimeout(() => window.print(), 600); return () => clearTimeout(t); }, []);

  return (
    <div className="pp-dcards" data-testid="print-dinner-cards-page">
      <div className="pp-dcards-bar no-print">
        <p><Scissors className="inline h-4 w-4 mr-1" /> {cards.length} cards · print, then cut along the dashed lines.</p>
        <div className="flex gap-2 flex-wrap">
          <Link to="/print/dinner-box" className="pp-ghost" data-testid="print-dinner-box-link"><Package className="h-4 w-4" /> Card box template</Link>
          <button className="pp-primary" onClick={() => window.print()} data-testid="print-dinner-cards-button"><Printer className="h-5 w-5" /> Print</button>
        </div>
      </div>
      {pages.map((page, i) => (
        <section key={page[0]?.q ?? i} className="pp-dcards-page" data-testid={`dinner-print-page-${i}`}>
          {page.map((c) => (
            <article key={c.q} className={`pp-dcard t-${c.id}`} data-testid="dinner-print-card">
              <header><span>{c.cat}</span><img src="/acorn-t.png" alt="" /></header>
              <p>{c.q}</p>
              <footer><Nice />™ Dinner Questions · BurrHaus Counseling</footer>
            </article>
          ))}
        </section>
      ))}
    </div>
  );
}
